var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4832 27.1777C37.094 27.6145 36.5883 27.9322 36.0436 28.1703L12.9688 37.938H35.0319C36.3939 37.938 37.4834 36.7867 37.4834 35.4365V27.4158V27.1774L37.4832 27.1777Z",
    fill: "#D6E3FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.343 26.4629C36.5883 25.9466 37.2107 24.4776 36.6659 23.1672L33.6696 15.7422C33.6308 15.6627 33.6308 15.6231 33.5917 15.5835C33.3971 16.1394 33.047 16.6158 32.6189 17.0526L14.9918 35.0394L35.343 26.4629Z",
    fill: "#D6E3FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2962 15.7422C32.269 14.7496 32.269 13.1615 31.2962 12.1688L25.7316 6.53035C25.6928 6.49075 25.6537 6.45086 25.6149 6.41125C25.6149 7.00673 25.4982 7.56259 25.2648 8.15839L15.7313 31.6644L31.2962 15.7422Z",
    fill: "#D6E3FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1477 28.1703L23.5916 7.40397C24.0975 6.13323 23.5137 4.66418 22.2686 4.10836L14.9921 1.0512C14.9142 1.0116 14.8754 1.0116 14.7975 1.0116C15.0309 1.52786 15.1476 2.12337 15.1476 2.71882L15.1477 28.1703Z",
    fill: "#D6E3FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3188 2.71872C13.3188 1.32886 12.2293 0.217163 10.8673 0.217163H2.96813C1.60607 0.217163 0.516602 1.32893 0.516602 2.71872V35.3969C0.516602 36.7867 1.60614 37.8984 2.96813 37.8984H10.8284C12.1904 37.8984 13.2799 36.7866 13.2799 35.3969L13.2796 2.71872H13.3188ZM6.89845 33.6895C5.65312 33.6895 4.64155 32.6572 4.64155 31.3865C4.64155 30.1159 5.65319 29.0836 6.89845 29.0836C8.1437 29.0836 9.15534 30.1159 9.15534 31.3865C9.15534 32.6572 8.1437 33.6895 6.89845 33.6895Z",
    fill: "#1676FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.6c9471715e55b4f38cadd67d8f360d1a.svg";
export { ForwardRef as ReactComponent };